module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-step-counter text-center"
  }, [_c('p', {
    staticClass: "font-blue"
  }, [_c('b', [_vm._v(_vm._s(_vm.computedStepText))])]), _vm._v(" "), _vm._l((_vm.steps), function(step, $index) {
    return _c('span', {
      class: {
        'bg-blue': _vm.process === step.key, 'bg-grey-cascade': _vm.process !== step.key
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-524341c5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/StepCounter.vue
// module id = 429
// module chunks = 1